import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";

export const GET_LINE_ITEM_PROCEDURE_CODE_LIST =
  "GET_LINE_ITEM_PROCEDURE_CODE_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/CustomCode/GetLineItemProcedureCodeList`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_LINE_ITEM_PROCEDURE_CODE_LIST, service, mock);
